import HumanResourcesDashboardTemplate from "Components/templates/hr/dashboard";

const HumanResourcesDashboard = () => {
  document.title = "Human Resources Dashboard | IbexIQ";

    return <HumanResourcesDashboardTemplate />
}

export default HumanResourcesDashboard;